var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAcceptingOpenIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 67,
    viewBox: "0 0 83 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.052 65.2372C59.7894 65.2372 74.1684 50.8572 74.1684 33.1186C74.1684 15.38 59.7894 1 42.052 1C24.3146 1 9.93555 15.38 9.93555 33.1186C9.93555 50.8572 24.3146 65.2372 42.052 65.2372Z",
    fill: "white",
    stroke: "#231F20",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5117 21.6579C20.5117 21.6579 22.1634 14.8557 29.3208 13.938C29.3208 13.938 35.3197 13.1924 38.2331 19.4211C38.2331 19.4211 29.814 13.2382 20.5117 21.6464V21.6579Z",
    fill: "#231F20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5808 21.6579C63.5808 21.6579 61.9291 14.8557 54.7717 13.938C54.7717 13.938 48.7728 13.1924 45.8594 19.4211C45.8594 19.4211 54.2899 13.2382 63.5808 21.6579Z",
    fill: "#231F20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 59.4895C1 59.4895 3.40873 43.4417 6.25333 45.8621C6.25333 45.8621 10.3252 32.487 14.9821 35.7103C19.639 38.9336 16.3585 49.3836 16.3585 49.3836C16.3585 49.3836 18.4117 47.1353 18.8361 49.1886C19.2605 51.2419 10.1073 63.0111 10.1073 63.0111",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1 59.4895C1 59.4895 3.40873 43.4417 6.25333 45.8621C6.25333 45.8621 10.3252 32.487 14.9821 35.7103C19.639 38.9336 16.3585 49.3836 16.3585 49.3836C16.3585 49.3836 18.4117 47.1353 18.8361 49.1886C19.2605 51.2419 10.1073 63.0111 10.1073 63.0111",
    stroke: "#231F20",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5438 59.4895C81.5438 59.4895 79.135 43.4417 76.2904 45.8621C76.2904 45.8621 72.2185 32.487 67.5616 35.7103C62.9048 38.9336 66.1852 49.3836 66.1852 49.3836C66.1852 49.3836 64.1321 47.1353 63.7077 49.1886C63.2833 51.2419 72.4365 63.0111 72.4365 63.0111",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5438 59.4895C81.5438 59.4895 79.135 43.4417 76.2904 45.8621C76.2904 45.8621 72.2185 32.487 67.5616 35.7103C62.9048 38.9336 66.1852 49.3836 66.1852 49.3836C66.1852 49.3836 64.1321 47.1353 63.7077 49.1886C63.2833 51.2419 72.4365 63.0111 72.4365 63.0111",
    stroke: "#231F20",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5643 28.209C38.5643 28.209 33.0816 36.0551 23.7793 28.989L38.5643 28.209Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5643 28.209C38.5643 28.209 33.0816 36.0551 23.7793 28.989",
    stroke: "#231F20",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5352 28.209C46.5352 28.209 52.0179 36.0551 61.3202 28.989L46.5352 28.209Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5352 28.209C46.5352 28.209 52.0179 36.0551 61.3202 28.989",
    stroke: "#231F20",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4333 50.5443C34.3468 52.4714 37.8222 53.6415 41.6074 53.6415C45.8513 53.6415 49.7053 52.1846 52.7908 49.8331C48.9368 47.4472 41.963 47.4357 41.963 47.4357C35.2529 47.4127 31.7774 50.2461 31.4219 50.5443H31.4333Z",
    fill: "#F01F29",
    stroke: "#F01F29",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4275 39.4297C24.196 44.454 27.1438 48.7555 31.2731 51.4856C34.1865 53.4127 37.662 54.5828 41.4471 54.5828C45.6911 54.5828 49.545 53.126 52.6305 50.7744C56.2207 48.0329 58.7556 44.0525 59.4667 39.4526C51.69 42.7333 38.3616 45.9566 23.416 39.4297H23.4275Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcceptingOpenIcon);
export default __webpack_public_path__ + "static/media/accepting-open-icon.1515170ab3273935e2f8f77b7d9e7699.svg";
export { ForwardRef as ReactComponent };